/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//  jQuery(document).ready( function($){
if (jQuery('.block__image_with_text_overlay').length > 0) {
  jQuery('body').addClass('with-hero-image');
}
// });

var free_delivery_enable = false;
// $.ajax({
//   type: "GET",
//   url: "https://noisy-glade-73f8.slofoodgroup3745.workers.dev",
//   success: function(result){
//     let allowedCountries = ['US', 'CA', 'GB', 'AU'];
//     let allowedContinents = ['EU'];
//     let selectedContinent = localStorage.getItem('selected-continent');
//     let selectedCurrency = localStorage.getItem('selected-currency');
//     if(result.country == 'US') free_delivery_enable = true;
//     if(result.country != selectedCurrency && allowedCountries.includes(result.country)) {
//       localStorage.setItem('selected-continent', result.continent);
//       localStorage.setItem('selected-currency', result.country);
//       $(".currency-switcher__form input[name=country_code]").val(result.country).change().parents("form").submit();
//     }
//     else if(result.continent != selectedContinent && allowedContinents.includes(result.continent)) {
//       localStorage.setItem('selected-continent', result.continent);
//       localStorage.setItem('selected-currency', result.country);
//       $(".currency-switcher__form input[name=country_code]").val(result.country).change().parents("form").submit();
//     }
//   }
// });


document.addEventListener('DOMContentLoaded', () => {

  returnUserToSearchIcon();
  paginationAccessibility();

  const menuAdjuster = () => {
    const submenus = document.querySelectorAll('nav ul li.desktop_menu.desktop_nav ul li.js-menu-holder .js-submenu .dropdown__wrapper .dropdown__content-list');

    if (!submenus.length) {
      return;
    }

    /* 60 is used to account for the scrollbar width and some spacing */
    const viewportWidth = document.documentElement.clientWidth - 60;

    submenus.forEach((submenu) => {
      /* Right is the amount of space between the start of the viewport and the right edge of the submenu */
      const { right, left } = submenu.getBoundingClientRect();

      /* But it doesn't include the padding of the submenu, so we need to add that in */
      const paddingInlineRight = parseFloat(getComputedStyle(submenu).getPropertyValue('padding-inline-end'));
      const paddingInlineLeft = parseFloat(getComputedStyle(submenu).getPropertyValue('padding-inline-start'));

      /*
        If we already have calculated this at some point,
        the `right` value will be affected by the overflow offset
        so we need to sum the current offset to the total as well.
      */
      const currentOverflowAmountRight = getComputedStyle(submenu).getPropertyValue('--overflow-amount-right');
      const parsedCurrentOverflowAmountRight = currentOverflowAmountRight ? parseFloat(currentOverflowAmountRight) : 0;
      const totalWidthRight = right + paddingInlineRight + parsedCurrentOverflowAmountRight;
      const currentOverflowAmountLeft = getComputedStyle(submenu).getPropertyValue('--overflow-amount-right');
      const parsedCurrentOverflowAmountLeft = currentOverflowAmountLeft ? parseFloat(currentOverflowAmountLeft) : 0;
      const totalWidthLeft = parsedCurrentOverflowAmountLeft === 0
        ? (left - paddingInlineLeft - 40)
        : (left - paddingInlineLeft - Math.abs(parsedCurrentOverflowAmountLeft));

      const hasOverflownRight = totalWidthRight > viewportWidth;
      const hasOverflownLeft = totalWidthLeft < 0;

      const submenuContainer = submenu.closest('.dropdown');

      if (hasOverflownRight) {
        submenuContainer.classList.add('submenu-dropping-left');
        submenuContainer.style.setProperty("--overflow-amount-right", `${totalWidthRight - viewportWidth}px`);
      } else if (submenuContainer.classList.contains('submenu-dropping-left')) {
        submenuContainer.classList.remove('submenu-dropping-left');
        submenuContainer.style.setProperty("--overflow-amount-right", `${0}px`);
      }

      if (hasOverflownLeft) {
        submenuContainer.classList.add('submenu-dropping-left');
        submenuContainer.style.setProperty("--overflow-amount-right", `${totalWidthLeft}px`);
      } else if (submenuContainer.classList.contains('submenu-dropping-left')) {
        submenuContainer.classList.remove('submenu-dropping-left');
        submenuContainer.style.setProperty("--overflow-amount-right", `${0}px`);
      }
    });
  };

  // Initial run
  menuAdjuster();

  // Run again on window resize (with debounce)
  let menuAdjusterTimer;
  window.addEventListener('resize', () => {
    clearTimeout(menuAdjusterTimer);
    menuAdjusterTimer = setTimeout(menuAdjuster, 150);
  });

  // Ensure menu is adjusted on load and after 1s (for Safari)
  window.addEventListener('load', menuAdjuster);

  window.dispatchEvent(new Event('resize'));

  // window.addEventListener('resize', menuAdjuster);
  // setTimeout(() => {
  //   // Trying to give alternatives to Safari refusing to fire the resize without user interaction
  //   document
  //     .querySelector('.menu.sfg-mega-menu.first-menu')
  //     .addEventListener('mouseenter', () => window.dispatchEvent(new Event('resize')));

  //   window.dispatchEvent(new Event('resize'))
  // }, 1000);

  const setDropdownWidths = () => {
    // Only apply for desktop viewports
    if (window.matchMedia('(min-width: 1199px)').matches) {
      document.querySelectorAll('.menu.sfg-mega-menu .sub-menu').forEach(menu => {
        const content = menu.querySelector('.dropdown__content');
        if (content) {
          const targetWidth = content.scrollWidth + 'px';
          content.style.minWidth = targetWidth;
        }
      });
    }
  };

  // Run initially
  setDropdownWidths();

  // Run again on window resize (with debounce)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setDropdownWidths, 150);
  });
});


(function ($) {
  // $(document).ready(() => {
  //   $('.menu.sfg-mega-menu .sub-menu').each((i, o) => {
  //     const menu = $(o);
  //     const content = menu.find('.dropdown__content')[0];
  //     const targetWidth = content.scrollWidth + 'px';

  //     menu.on('mouseover', () => {
  //       if (window.matchMedia('(min-width: 1199px)').matches) {
  //         content.style.minWidth = targetWidth;
  //       }
  //     });
  //   });
  // });

  $.fn.mmenuDoLiveProductSearch = function () {
    let el = $(this);
    let term = '*' + el.val() + '*';
    let form = el.closest('form');
    let cont = $('#nav');

    $.ajax({
      url: form.attr('action'),
      data: {
        type: 'product',
        view: 'json',
        q: term,
      },
      dataType: "json",
      type: 'get',
    }).done(function (data) {

      if (typeof data.results != "undefined" && data.results.length > 0) {
        let panel = cont.find('.mm-panels .mm-opened.mm-current');
        let resultsCont = panel.find('.mm-listview');
        let title = cont.find('.mm-navbar-top .mm-title');
        let prev = title.parent().find('.mm-prev');
        panel.find('.mm-listview--search').remove();
        resultsCont.hide();
        panel.append('<ul class="mm-listview mm-listview--search"></ul>');
        let searchListView = panel.find('.mm-listview--search');
        resultsCont.find('li:not(.search-result)').hide();
        resultsCont.find('.search-result').remove();

        if (typeof cont.attr('data-searchtext') != "undefined") {
          let currentText = title.html();
          if (typeof title.attr('data-originaltext') == "undefined") {
            title.attr('data-originaltext', currentText)
          }
          title.html(cont.attr('data-searchtext'));
          prev.addClass('mm-hidden');
        }

        data.results.forEach(function (result) {
          let newEl = $('<li class="search-result mm-listitem"><a class="mm-listitem__text" data-href="' + result.url + '" href="' + result.url + '">' + result.title + '</a></li>');
          newEl.appendTo(searchListView);
        });
      }
    });
  };

  $(document).ready(function () {

    $('.tab-heading').click(function () {
      var tabId = $(this).attr('data-tab-id');
      var $tabContent = $('#' + tabId);
      var $section = $(this).parents('.shopify-section');

      if ($tabContent.length) {
        $section.find('.tab-content').removeClass('is-active');
        $section.find('.tab-heading').removeClass('is-active').attr('aria-selected', 'false').attr('tabindex', '-1');

        $(this).addClass('is-active').attr('aria-selected', 'true').attr('tabindex', '0');
        $tabContent.addClass('is-active')
      }
    });

    if ($('.purchase-details').length) {
      $(window).scroll(function () {
        var current = $(window).scrollTop();

        if (current > $('.purchase-details').offset().top + 50) {
          $('.stickybar-product-controls').addClass('is-visible');
        }
        else {
          $('.stickybar-product-controls').removeClass('is-visible');
        }

        _lastScrollPosition = current;
      });
    }

    // fixMobileReviewsPosition();

    let API = $('#nav').data('mmenu');
    if (typeof API != "undefined") {
      API.bind('closed', function () {
        let cont = $('#nav .mm-panels .mm-opened.mm-current');
        let title = $('#nav').find('.mm-navbar-top .mm-title');
        let prev = title.parent().find('.mm-prev');

        title.html(title.attr('data-originaltext'));
        title.removeAttr('data-originaltext');
        prev.removeClass('mm-hidden');

        cont.find('li:not(.search-result)').show();
        cont.find('li.search-result').remove();

        $('#nav .mm-search input').val('');
      });
    }


    $(document).on('click', '.variant_item', function () {
      var variant_price = parseFloat($(this).data('variant-price'));

      $(this).closest('#product-form')
        .find('.shop_pay')
        .toggleClass('hide_pay', variant_price <= 5000);

      let $price = $(this).closest('#product-form').find('.add_to_cart .price');
      if (!$price.hasClass('recharge-inner-most-price')) {
        $price.text(Shopify.formatMoney((variant_price / 100.0).toFixed(2), $("body").data("money-format")));
      }
    })

    var searchInterval = setInterval(searchElement, 500);

    function stopSearch() {
      clearInterval(searchInterval);
    }

    function searchElement() {
      if ($('.stamped-badge-stars').length > 0) {
        if (free_delivery_enable) {
          $('.free-delivery-icon').addClass('active');
          $('.sfg-mega-menu').addClass('has-free-shipping');
        }
        stopSearch();
      }
    }

    setTimeout(function () {
      stopSearch();
    }, 30000);
  });

  //article products slider setup slider

  $slick_slider = $('body.article .products');
  settings_slider = {
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  slick_on_mobile($slick_slider, settings_slider);
  function slick_on_mobile(slider, settings) {
    $(window).on('load resize', function () {
      if ($(window).width() > 992) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  };

  //article products slider setup slider
  $slick_article_slider = $('.related_article');
  slick_on_mobile($slick_article_slider, settings_slider);

  $(window).on('load', function () {
    $('.mm-listview li a[href*="#"]').each(function () {
      let el = $(this);
      if (typeof el.data('href') != "undefined" && el.data('href') != null) el.attr('href', el.data('href'));
    });

    $('#cart').each(function () {
      $(this)[0].setAttribute('action', '/checkout');
    });
  });

  $(document).on("keyup", "#nav .mm-search input", function () {
    $(this).mmenuDoLiveProductSearch();
  });

  $(document).on('click', '.mm-btn.mm-clear', function (e) {
    let cont = $('#nav');
    let panel = cont.find('.mm-panels .mm-opened.mm-current');
    let resultsCont = panel.find('.mm-listview');
    let resultsContItems = panel.find('.mm-listview li');
    $('.mm-navbar-top .mm-prev').removeClass('mm-hidden')
    $('.mm-navbar-top .mm-title').text($('.mm-navbar-top .mm-title').attr('data-originaltext'))
    panel.find('.mm-listview--search').remove();
    resultsCont.show();
    resultsContItems.show();
  });

})(jQuery);


(function ($) {
  $(function () {
    const $modal = $('.sf-vanilla-calculator__modal');
    const $calculator = $('.sf-vanilla-calculator');
    const $results = $calculator.find('.sf-vanilla-calculator__results');
    const multipliers = $calculator.data('multipliers');

    function resetModal() {
      $modal.fadeOut(function () {
        $results.hide();
        $results.text('');
        $calculator.find('input, select').each(function () {
          $(this).val($(this).data('default'));
        });
      });
    }

    $('.version-1').on('click', function (event) {
      event.preventDefault();
      $('.sf-vanilla-calculator').show();
      $('.sf-vanilla-calculator-r').hide();
    })

    $('.version-2').on('click', function (event) {
      event.preventDefault();
      $('.sf-vanilla-calculator').hide();
      $('.sf-vanilla-calculator-r').show();
    })

    $modal.on('click', function (event) {
      resetModal();
    });

    $modal.find('[data-close]').on('click', function (event) {
      event.preventDefault();
      resetModal();
    });

    $('.sf-vanilla-calculator').on('click', function (event) {
      event.stopPropagation();
    });

    $('.sf-vanilla-calculator__trigger').on('click', function (event) {
      event.preventDefault();
      $modal.fadeIn();
    });

    $calculator.on('submit', function (event) {
      event.preventDefault();

      const extract = parseFloat($calculator.find('input[name="extract"]').val());
      const unit = $calculator.find('select[name="unit"]').val();
      const grade = $calculator.find('select[name="grade"]').val();
      const strength = parseInt($calculator.find('select[name="strength"]').val());

      let average = $calculator.data('average');
      if (average == null) {
        average = multipliers[grade].average;
      }

      if (isNaN(extract) || extract <= 0) {
        alert('You must input a positive numeric value for the extract');
        return;
      }

      let weight = extract * multipliers[grade].units[unit] * strength;
      let beans_min = Math.ceil(weight / average.min);
      let beans_max = Math.floor(weight / average.max);

      // Build text from data-text-template
      const template = $results.data('text-template');
      const finalText = template
        .replace('{weight}', weight.toFixed(2))
        .replace('{beans}', beans_max + ' - ' + beans_min);

      // Force screen-reader announcement
      $results.text(''); // clear first to force mutation

      setTimeout(function () {
        $results.text(finalText); // this triggers role="status"
      }, 50);

      // Show visually AFTER mutation is scheduled
      $results.fadeIn();
    });

  })

  $(function () {
    const $calculator = $('.sf-vanilla-calculator-r');
    const $results = $calculator.find('.sf-vanilla-calculator__results-r');
    const multipliers = $calculator.data('multipliers');
    const grade = $calculator.find('select[name="grade"]').val();

    // this is to cut some issues with this script on load where
    // the pages have no calculator.
    if (multipliers == null) return;

    let average = $calculator.data('average');
    if (average == null) {
      average = multipliers[grade].average.min
    }

    $('.sf-vanilla-calculator-r').on('click', function (event) {
      event.stopPropagation();
    });

    $calculator.on('submit', function (event) {
      event.preventDefault();

      const beans = $calculator.find('select[name="unit"]').val() === 'oz'
        ? parseFloat($calculator.find('input[name="beans"]').val())
        : parseFloat($calculator.find('input[name="beans"]').val()) * average;

      const strength = parseInt($calculator.find('select[name="strength"]').val());

      if (isNaN(beans) || beans <= 0) {
        alert('You must input a positive numeric value for the beans');
        return;
      }

      let extract = beans / (multipliers[grade].units['cup'] * strength);

      // Build text using data-text-template
      const template = $results.data('text-template');
      const finalText = template.replace('{extract}', extract.toFixed(2));

      // Force screen reader announcement
      $results.text(''); // clear first to guarantee DOM mutation

      setTimeout(function () {
        $results.text(finalText); // triggers role="status"
      }, 50);

      // Show visually AFTER mutation is scheduled
      $results.fadeIn();
    });

  });

  $('.footer__middle .title').click(function () {
    const parent = $(this).closest('div');
    if (parent.hasClass('opened')) {
      parent.removeClass('opened');
    } else {
      parent.addClass('opened');
    }
  })
  function sloRemoveStyleTags() {
    if (window.location.href.indexOf('tools/recurring/get-subscription-access') > -1) {
      console.log('Loaded')
      console.log($('style'));
      $('style').each(function () {
        console.log($(this))
        $(this).remove();
      });
    }
  }

  $(document).ready(function () {
    sloRemoveStyleTags();
  })
  $(document).ajaxComplete(function () {
    sloRemoveStyleTags();
  });
}(jQuery));


// Currencies Switcher Code.
(function ($) {
  $(document).ready(function () {
    let countries = {
      "USD": "US",
      "GBP": "GB",
      "EUR": "FR",
      "CAD": "CA",
      "JPY": "JP",
      "AUD": "AU",
      "INR": "IND",
    };

    $(document).on('change', 'select.currencies', function (e) {
      let selected_code = countries[$(this).val()];
      $(".currency-switcher__form input[name=country_code]").val(selected_code).change().parents("form").submit();
    });

    $(document).on('click', '.currenciesul li', function (e) {
      if ($(".currency-switcher__form input[name=country_code]").length > 0) {
        let code = $(this).data('currency_value');
        //$('.currencies').val(code).trigger('change');
        $(".currency-switcher__form input[name=country_code]").val(countries[code]).change().parents("form").submit();

        if (code == 'GBP') {
          code = 'GBP(£)';
        } else if (code == 'EUR') {
          code = 'EUR(€)';
        } else if (code == 'JPY') {
          code = 'JPY(¥)';
        } else if (code == 'AUD') {
          code = 'AUD($)';
        } else if (code == 'CAD') {
          code = 'CAD($)';
        } else if (code == 'INR') {
          code = 'INR(₹)';
        } else {
          code = 'USD($)';
        }

        $('.selected_currency .currency').text(code);
      }
    });
  });
}(jQuery));


window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'open') {
    if (document.querySelector(".needsclick .needsclick:nth-child(2)")) {
      document.querySelector(".needsclick .needsclick:nth-child(2)").setAttribute('aria-modal', true);
      document.querySelector(".needsclick .needsclick:nth-child(2)").setAttribute('role', 'dialog');
      if (document.querySelector(".needsclick .needsclick:nth-child(2) input[type='email']")) {
        document.querySelector(".needsclick .needsclick:nth-child(2) input[type='email']").setAttribute('aria-required', true);
      }
    }
  }
});

let observerConfig = { attributes: true, childList: true, subtree: true };

function stampedObserver() {
  document.querySelectorAll('#stamped-reviews-widget:not(.binded)').forEach((ele) => {
    let callback = () => {
      if (ele.querySelector('.stamped-badge-stars') && ele.querySelector('.stamped-badge-stars').getAttribute('tabindex') == null) {
        //ele.querySelector('.stamped-badge-stars').setAttribute('tabindex',0);
      }
      if (ele.querySelector('#stamped-badge-total') && ele.querySelector('#stamped-badge-total').getAttribute('tabindex') == null) {
        //ele.querySelector('#stamped-badge-total').setAttribute('tabindex',0);
      }
      if (ele.querySelector('#stamped-badge-title') && ele.querySelector('#stamped-badge-title').getAttribute('tabindex') == null) {
        //ele.querySelector('#stamped-badge-title').setAttribute('tabindex',0);
      }
    };
    ele.classList.add('binded');
    let observer = new MutationObserver(callback);
    observer.observe(ele, observerConfig);
  });
}

stampedObserver();

// let observer1 = new MutationObserver(()=>{
//   stampedObserver();
// });

// observer1.observe(document, config);

async function fetchBrowsingContextSuggestions() {
  if (document.querySelector('.google-ratings.google-ratings-footer')) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}browsing_context_suggestions.json`
        + `?country[enabled]=true`
        + `&country[exclude]=${window.Shopify.country}`
        + `&language[enabled]=true`
        + `&language[exclude]=${window.Shopify.language}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      const country = data.detected_values.country.handle;
      const googleRating = document.querySelector('.google-ratings.google-ratings-footer').closest('.three.columns');

      if (country != 'US') {
        googleRating.classList.add('hide');
      }
    } catch (error) {
      console.log('Error fetching browsing context suggestions:', error);
    }
  }
}

fetchBrowsingContextSuggestions();

jQuery(document).ready(function ($) {
  if ($('.shopify-section.hero').length > 0) {
    let headerHeight = $('.header').outerHeight();
    $('body').css('padding-top', headerHeight + 'px');
  }
});

// Hide help widget by default
if (typeof zE !== 'undefined') {
  zE('webWidget', 'hide');
}
/** Show/hide Chat window */
jQuery(document).ready(function ($) {
  $('a[href="#livechat"]').on('click', function (e) {
    e.preventDefault();
    let isOpen = $(this).data('open');
    if (typeof $zopim !== 'undefined') {
      if (isOpen === false) {
        $(this).data('open', true);
        $zopim.livechat.window.show();
      } else {
        $(this).data('open', false);
        $zopim.livechat.window.hide();
      }

    }
  });
});

jQuery(document).ready(function ($) {
  var mediaQuery = window.matchMedia('(max-width: 767px)');
  // Check if the media query is true
  if (mediaQuery.matches) {
    jQuery('.section-blog-posts-gallery__right').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      dots: false,
      infinite: false
    });

    jQuery('.index #instafeed').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      dots: false,
      infinite: false,
    });

  }

  var productsSliderOptions = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    dots: false,
    infinite: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };
  jQuery('.product-list-tabs-contents .products').slick(productsSliderOptions);
  jQuery('.product-list-tabs-contents .products .product___grid').removeAttr('tabindex');

  jQuery('.product-list-tabs-headings').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    dots: false,
    infinite: false,
    centerMode: false,
    accessibility: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 60) {
      $('.header, #header').addClass("is-scrolled");
    } else {
      $('.header, #header').removeClass("is-scrolled");
    }
  });

  $('.section-product-list-tabs .tab-heading').click(function () {
    var tabId = $(this).find('span').attr('data-tab-id');
    var $tabContent = $('#' + tabId);
    var $section = $(this).parents('.shopify-section');
    let slider = $section.find('.product-list-tabs-headings');

    let slickIndex = $(this).data("slick-index");

    if (mediaQuery.matches) {
      if (slider.slick('slickCurrentSlide') !== slickIndex) {
        slider.slick('slickGoTo', slickIndex);
      }
    }


    if ($tabContent.length) {
      $section.find('.tab-content').removeClass('is-active');
      $section.find('.tab-heading').removeClass('is-active');

      $(this).addClass('is-active');
      $tabContent.addClass('is-active')
      $tabContent.find('.tab-products .products.slick-slider').slick('unslick');
      $tabContent.find('.tab-products .products').slick(productsSliderOptions);
      $tabContent.find('.tab-products .products .product___grid').removeAttr('tabindex');
    }
  });

  //Adding tabindex to PDP elements
  if ($('.summary-rating').length > 0) {
    $('.summary-rating').attr('tabindex', '0');
    $('.stamped-modal-close').attr('tabindex', '0');
    $('body').keydown(function (e) {
      if (e.which === 27) {
        if ($('.stamped-ugc-modal-wrapper').length > 0) {
          $('.stamped-summary-actions-newquestion').focus();
        }
      }
    })
  }



  /* Focus banner on homepage */
  if ($('.promo_banner').length > 0) {
    $('.promo_banner').focus();
  }

  // Click to move the focus
  if ($(".mm-listview").length) {
   
    $('.cart-button').click((e) => {
      e.preventDefault();
      setTimeout(() => {
        jQuery(e.target).attr('data-return-focus', 'true');
        const cartDrawer = document.querySelector('#cart');
        cartDrawer.focus();
      }, 100);
    });

  }

  $(document).on('click', '.languagesul li', function () {
    let el = $(this);
    window.location.href = el.attr('data-url');
  });

  $(document).on('keydown', '.languagesul li', function (e) {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      let el = $(this);
      window.location.href = el.attr('data-url');
    }
  });

  $(document).on('click', '.header-currency.mobile a[data-href]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).parent().find('.mm-next').click();

    const observer = new MutationObserver(callback)
    const options = {
      attributes: true
    }

    function callback(mutationList, observer) {
      mutationList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // handle class change
          $('#header .icon-menu').click();
          observer.disconnect();
        }
      })
    }

    observer.observe($('html')[0], options)

    return false;
  });
  

});


/* Show/hide vanilla calculator fixed bar */

jQuery(document).ready(function ($) {
  const $block = $('#calculator-vanilla__block')
  if ($block.length === 0) return
  const $calculator = $("#calculator-vanilla")

  $('#calculator-vanilla__block a').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $calculator.offset().top - 200
    }, 1000);
  })

  $(window).scroll(function () {
    const top_of_element = $calculator.offset().top;
    const bottom_of_element = $calculator.offset().top + $calculator.outerHeight();
    const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    const top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
      $block.fadeOut(300)
    } else {
      $block.fadeIn(300)
    }
  });
});

// Announce Added to cart for accessibility.
document.addEventListener('cart:added', function (event) {
  const toastMessage = document.getElementById('cart-toast-message');
  if (!toastMessage) return;

  const message = 'Product added to your cart';
  toastMessage.textContent = '';
  setTimeout(() => {
    toastMessage.textContent = message;
  }, 10);
});


// Tabs Accessibility
document.addEventListener("DOMContentLoaded", () => {
  const tabHeadings = document.querySelectorAll(".product-list-tabs-container .tab-heading, .product-tabs-container .tab-heading");
  const tabContents = document.querySelectorAll(".product-list-tabs-container .tab-content, .product-tabs-container .tab-content");

  // Enhance tabs with proper ARIA roles
  tabHeadings.forEach((tab, index) => {
    const tabId = tab.dataset.tabId || tab.querySelector("span")?.dataset.tabId;

    tab.setAttribute("role", "tab");
    tab.setAttribute("id", `tab-${index}`);
    tab.setAttribute("aria-selected", tab.classList.contains("is-active") ? "true" : "false");
    tab.removeAttribute("aria-hidden");
    tab.setAttribute("aria-controls", tabId);

    // Ensure focusable
      tab.tabIndex = tab.classList.contains("is-active") ? "0" : "-1";
  });

  // Enhance tab panels
  tabContents.forEach((panel, index) => {
    panel.setAttribute("role", "tabpanel");
    panel.setAttribute("aria-labelledby", `tab-${index}`);
    panel.setAttribute("tabindex", "0"); // so screen reader users can reach it
    panel.hidden = !panel.classList.contains("is-active");
  });

  // // Handle switching
  // tabHeadings.forEach((tab) => {
  //   tab.addEventListener("click", () => {
  //     const targetId = tab.querySelector("span")?.dataset.tabId;

  //     // Update tabs
  //     tabHeadings.forEach((t) => {
  //       const isActive = t === tab;
  //       t.classList.toggle("is-active", isActive);
  //       t.setAttribute("aria-selected", isActive ? "true" : "false");
  //       t.removeAttribute("aria-hidden");
  //       t.setAttribute("tabindex", isActive ? "0" : "-1");
  //     });

  //     // Update panels
  //     tabContents.forEach((panel) => {
  //       const match = panel.id === targetId;
  //       panel.classList.toggle("is-active", match);
  //       panel.hidden = !match;
  //     });
  //   });

  //   // Optional: keyboard support (Left/Right arrow)
  //   tab.addEventListener("keydown", (e) => {
  //     const currentIndex = Array.from(tabHeadings).indexOf(tab);
  //     let newIndex = currentIndex;

  //     if (e.key === "ArrowRight") newIndex = (currentIndex + 1) % tabHeadings.length;
  //     if (e.key === "ArrowLeft") newIndex = (currentIndex - 1 + tabHeadings.length) % tabHeadings.length;

  //     if (newIndex !== currentIndex) {
  //       tabHeadings[newIndex].click();
  //       tabHeadings[newIndex].focus();
  //     }
  //   });
  // });
});


// Stamped badges accessibility fix
// Watches for injected stamped badges and fixes their aria attributes
// to make them accessible.
const fixStampedAria = (badge) => {
  const starRating = badge.querySelector('.stamped-badge-starrating');
  if (starRating) {
    // Remove aria-hidden if present
    if (starRating.hasAttribute('aria-hidden')) {
      starRating.removeAttribute('aria-hidden');
    }

    // Try to get aria-label or data-rating from parent
    const ariaLabel = badge.getAttribute('aria-label');
    const rating = badge.getAttribute('data-rating');

    // Remove attribute
    badge.removeAttribute('aria-label');

    // Build a meaningful label
    const labelText = ariaLabel || (rating ? `Rated ${rating} out of 5 stars` : null);

    if (labelText) {
      starRating.setAttribute('aria-label', labelText);
      starRating.setAttribute('role', 'img');
    }
  }
};

// Fix for stamped badge in header
const fixHeaderStampedAria = (badge) => {

  badge.querySelectorAll('.stamped-fa').forEach((ele) => {
    ele.setAttribute('aria-hidden', 'true');
  })

  const rating = badge.getAttribute('data-rating');
  const starRating = badge.querySelector('.stamped-reviews-rating');

  // Build a meaningful label
  const labelText = rating ? `Rated ${rating} out of 5 stars` : null;

  if (labelText) {
    starRating.setAttribute('aria-label', labelText);
    starRating.setAttribute('role', 'img');
  }
};

// Observe for stamped badge injections
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches('.stamped-badge') || node.matches('#stamped-badge-2') ) {
         
          if( node.classList.contains('stamped-badge') ){
            fixStampedAria(node);
          } else {
            fixHeaderStampedAria(node);
          }
          
        } else if (node.querySelector && node.querySelector('.stamped-badge')) {
          node.querySelectorAll('.stamped-badge').forEach(fixStampedAria);
        }
      }
    });
  });
});

// Start observing the entire document (or narrow to container if possible)
observer.observe(document.body, { childList: true, subtree: true });

// Run once initially (for badges already in DOM)
document.querySelectorAll('.stamped-badge').forEach(fixStampedAria);

function paginationAccessibility() {
  const intervalLimit = 5;
  let intervalCount = 0;

  const paginationInterval = setInterval(() => {
    intervalCount++;
    if (intervalCount > intervalLimit) {
      clearInterval(paginationInterval);
      return;
    }

    const paginationWrapper = document.querySelector('.ais-Pagination');
    const pagination = document.querySelector('ul.ais-Pagination-list');

    if (!pagination) return;

    const navWrapper = document.createElement('nav');
    navWrapper.setAttribute('aria-label', 'Pagination');

    navWrapper.appendChild(pagination);
    paginationWrapper.appendChild(navWrapper);
    clearInterval(paginationInterval);
  }, 500);
}

// Mutation observer for flex-active slider images
// Adds aria-current="true" to the <li> containing the active slider image
function setupFlexActiveObserver() {
  // Function to update aria-current based on flex-active class
  function updateAriaCurrent() {
    // Remove aria-current from all <li> elements first
    document.querySelectorAll('li[aria-current="true"]').forEach(li => {
      // li.removeAttribute('aria-current');
    });

    //
    document.querySelectorAll('.slides.slides-product-images-thumbs li').forEach(li => {
      li.querySelector('a').setAttribute('aria-hidden', 'true');
      li.querySelector('a').setAttribute('tabindex', '-1');
    });
    
    // Find all elements with flex-active class (could be img, a, or any element)
    const activeElements = document.querySelectorAll('.flex-active');
    
    // Add aria-current to the <li> containing each active element
    activeElements.forEach(activeElement => {
      // Find the closest parent <li>
      const parentLi = activeElement.closest('li');
      if (parentLi) {
        // parentLi.setAttribute('aria-current', 'true');

        document.querySelectorAll('.slides.slides-product-images-thumbs li.flex-active-slide').forEach(li => {
          li.querySelector('a').setAttribute('aria-hidden', 'false');
          li.querySelector('a').removeAttribute('tabindex');
        });
      }
    });
  }
  
  // Run immediately to handle elements already in the DOM
  updateAriaCurrent();
  
  // Debounce function to avoid too many updates
  let updateTimeout;
  function debouncedUpdate() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(updateAriaCurrent, 10);
  }
  
  // Create mutation observer to watch for class changes
  const observer = new MutationObserver(function(mutations) {
    let needsUpdate = false;
    
    mutations.forEach(function(mutation) {
      // Check if class attribute changed
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        const hadFlexActive = mutation.oldValue && mutation.oldValue.includes('flex-active');
        const hasFlexActive = target.classList && target.classList.contains('flex-active');
        
        // Update if flex-active was added, removed, or if the element currently has it
        if (hadFlexActive || hasFlexActive) {
          needsUpdate = true;
        }
      }
      
      // Check if nodes were added (new slider might be added dynamically)
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if added node has flex-active or contains elements with flex-active
            if (node.classList && node.classList.contains('flex-active')) {
              needsUpdate = true;
            } else if (node.querySelector && node.querySelector('.flex-active')) {
              needsUpdate = true;
            }
          }
        });
      }
    });
    
    if (needsUpdate) {
      debouncedUpdate();
    }
  });
  
  // Start observing the entire document for class attribute changes and child additions
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true, // Track old value to detect class changes
    childList: true,
    subtree: true
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupFlexActiveObserver);
} else {
  setupFlexActiveObserver();
}


function returnUserToSearchIcon() {
  const searchIcon = document.querySelector('.menu .icon-search');
  const searchClose = document.querySelector('.search-close');
  const dialog = document.querySelector('#search');
  if (!searchIcon || !searchClose || !dialog) return;

  const firstFocusableElement = dialog.querySelector('.search-close');
  const lastFocusableElement = dialog.querySelector('.search-submit');

  searchIcon.addEventListener('click', () => {
    modalTrap(dialog, firstFocusableElement, lastFocusableElement);
  });

  searchClose.addEventListener('click', () => {
    setTimeout(() => {
      searchIcon.focus();
    }, 100);
  });
}

function modalTrap(dialog, firstFocusableElement, lastFocusableElement) {
  dialog.addEventListener('keydown', function(e) {
    if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement?.focus();
    } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement?.focus();
    }
  });
}

//Mutation observer for Cart Drawer
document.addEventListener("readystatechange", (e) => {
  if(document.readyState === "complete") {
    const targetNode = document.getElementById("cart");
    if (!targetNode) return;

    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      for(const mutation of mutationList) {
        if(mutation.attributeName == "class") {

          //If the drawer is open, initiate trap focus
          if(mutation.target.classList.contains("mm-opened")) {
            trapFocusCustom(targetNode);
          }
          //Otherwise, remove trap focus
          else {
            removeTrapFocusCustom();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
          observer.observe(targetNode, config)
  }
});


// Store references to our event handlers so we can remove them.
/** @type {Record<string, (event: Event) => void>} */
const trapFocusHandlers = {};

/**
 * Get all focusable elements within a container.
 * @param {HTMLElement} container - The container to get focusable elements from.
 * @returns {HTMLElement[]} An array of focusable elements.
 */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/**
 * Trap focus within the given container.
 * @param {HTMLElement} container - The container to trap focus within.
 */
function trapFocusCustom(container) {
  // Clean up any previously set traps.
  removeTrapFocusCustom();

  // Gather focusable elements.
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    // If nothing is focusable, just abort—no need to trap.
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  // Keydown handler for cycling focus with Tab and Shift+Tab
  /** @type {(event: KeyboardEvent) => void} */
  trapFocusHandlers.keydown = (event) => {
    if (event.key !== 'Tab') return;

    const activeEl = document.activeElement;

    // If on the last focusable and tabbing forward, go to first
    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first?.focus();
    }
    // If on the first (or the container) and shift-tabbing, go to last
    else if (event.shiftKey && (activeEl === first || activeEl === container)) {
      event.preventDefault();
      last?.focus();
    }
  };

  // Focusin (capturing) handler to forcibly keep focus in the container
  /** @type {(event: FocusEvent) => void} */
  trapFocusHandlers.focusin = (event) => {
    // If the newly focused element isn't inside the container, redirect focus back.
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      // E.g., refocus the first focusable element:
      first?.focus();
    }
  };

  // Attach the handlers
  document.addEventListener('keydown', trapFocusHandlers.keydown, true);
  // Use capture phase for focusin so we can catch it before it lands outside
  document.addEventListener('focusin', trapFocusHandlers.focusin, true);

  // Finally, put focus where you want it.
  container.focus();
}

/**
 * Remove focus trap and optionally refocus another element.
 */
function removeTrapFocusCustom() {
  trapFocusHandlers.keydown && document.removeEventListener('keydown', trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin && document.removeEventListener('focusin', trapFocusHandlers.focusin, true);
}
